import React from 'react';
import { NavigateFunction, Route } from 'react-router-dom';
import App from '~/pages/App';
import CreateAccount from '~/pages/authentication/CreateAccount';
import Denied from '~/pages/authentication/Denied';
import Logout from '~/pages/authentication/Logout';
import NewPassword from '~/pages/authentication/NewPassword';
import ResetPassword from '~/pages/authentication/ResetPassword';
import ConnectedLayout from '~/pages/authentified/ConnectedLayout';
import * as HomeConnected from '~/pages/authentified/Home';
import Stats from '~/pages/backoffice/admin/stats/Stats';
import Trackings from '~/pages/backoffice/admin/stats/Trackings';
import UserTable from '~/pages/backoffice/admin/user/UserTable';
import BackOfficeLayout from '~/pages/backoffice/BackOfficeLayout';
import Files from '~/pages/backoffice/files/Files';
import * as HomeBackOffice from '~/pages/backoffice/Home';
import Hm from '~/pages/guest/Hm';
import Ideev from '~/pages/guest/Ideev';
import LoginPage from '~/pages/guest/Login';
import Thematique from '~/pages/guest/Thematique';
import ImAuth from '~/pages/utils/ImAuth';
import NotFound from '~/pages/utils/NotFound';
import Error from './Error';

export enum Role {
  Admin = 'Admin',
  Formateur = 'Formateur',
  User = 'User',
  Guest = 'Guest',
}

type RouteParam = {
  path: string;
  element: React.JSX.Element;
  rolesAuthorize: Role[];
};

export const routingDefault = (role: Role, navigate: NavigateFunction) => {
  switch (role) {
    case Role.User:
      navigate('/home');
      break;
    case Role.Admin:
      navigate('/bo/admin/stats');
      break;
    case Role.Formateur:
      navigate('/bo/home');
      break;
    default:
      navigate('/');
      break;
  }
};

// Routes à définir
// If empty array, no auth required
const routes: RouteParam[] = [
  {
    path: '/',
    element: <App />,
    rolesAuthorize: [],
  },
  {
    path: '/hm',
    element: <Hm />,
    rolesAuthorize: [],
  },
  {
    path: '/ideev',
    element: <Ideev />,
    rolesAuthorize: [],
  },
  {
    path: '/login',
    element: <LoginPage />,
    rolesAuthorize: [],
  },
  {
    path: '/thematique/:site/:thematique',
    element: <Thematique />,
    rolesAuthorize: [],
  },
  {
    path: '/bo/admin/users',
    element: (
      <BackOfficeLayout>
        <UserTable />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin],
  },
  {
    path: '/bo/admin/stats',
    element: (
      <BackOfficeLayout>
        <Stats />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin, Role.Formateur],
  },
  {
    path: '/bo/admin/trackings',
    element: (
      <BackOfficeLayout>
        <Trackings />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin, Role.Formateur],
  },
  {
    path: '/bo/home',
    element: (
      <BackOfficeLayout>
        <HomeBackOffice.default />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin, Role.Formateur],
  },

  {
    path: '/bo/files',
    element: (
      <BackOfficeLayout>
        <Files />
      </BackOfficeLayout>
    ),
    rolesAuthorize: [Role.Admin, Role.Formateur],
  },
  {
    path: '/home',
    element: (
      <ConnectedLayout>
        <HomeConnected.default />
      </ConnectedLayout>
    ),
    rolesAuthorize: [Role.Admin, Role.Formateur, Role.User],
  },
  {
    path: '/logout',
    element: <Logout />,
    rolesAuthorize: [],
  },
  {
    path: '/denied',
    element: <Denied />,
    rolesAuthorize: [],
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
    rolesAuthorize: [],
  },
  {
    path: '/new-password',
    element: <NewPassword />,
    rolesAuthorize: [],
  },
  {
    path: '/error',
    element: <Error />,
    rolesAuthorize: [],
  },
  {
    path: '/createAccount',
    element: <CreateAccount />,
    rolesAuthorize: [],
  },
  {
    path: '*',
    element: <NotFound />,
    rolesAuthorize: [],
  },
];

export const renderRoutes = () => {
  return routes.map((r, i) => {
    return (
      <Route
        path={r.path}
        key={i}
        element={
          <>
            <ImAuth rolesAuthorize={r.rolesAuthorize} />
            {r.rolesAuthorize.includes(Role.Guest) ? (
              <>{r.element}</>
            ) : (
              r.element
            )}
          </>
        }
      />
    );
  });
};
